var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-auth"},[_c('h2',[_vm._v("您暂无该页面的权限")]),_vm._v(" "),_c('h3',[_vm._v("如需获取权限，请联系贵司主账号"+_vm._s(_vm.accountDetail)+"操作分配权限。")])])}
var staticRenderFns = []

export { render, staticRenderFns }